import { withTimestamps } from './Timestamps'

type Block = { kind: 'p'; lines: string[] } | { kind: 'ul'; items: string[] }

/** Show notes (paragraphs and `-` bullets), with timestamps that seek the player. */
export function NotesView({ text, onSeek }: { text: string; onSeek: (ms: number) => void }) {
  const blocks: Block[] = []
  for (const raw of text.split('\n')) {
    const line = raw.trim()
    const last = blocks.at(-1)
    const bullet = /^[-*]\s+(.*)$/.exec(line)?.[1]
    if (!line) blocks.push({ kind: 'p', lines: [] })
    else if (bullet !== undefined) {
      if (last?.kind === 'ul') last.items.push(bullet)
      else blocks.push({ kind: 'ul', items: [bullet] })
    } else if (last?.kind === 'p') last.lines.push(line)
    else blocks.push({ kind: 'p', lines: [line] })
  }
  return (
    <div className="notes">
      {blocks.map((block, index) =>
        block.kind === 'ul' ? (
          <ul key={index}>
            {block.items.map((item, i) => (
              <li key={i}>{withTimestamps(item, onSeek)}</li>
            ))}
          </ul>
        ) : block.lines.length > 0 ? (
          <p key={index}>{withTimestamps(block.lines.join('\n'), onSeek)}</p>
        ) : null,
      )}
    </div>
  )
}
